import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type AddOnsState = {
  purchasedNoomPremium: boolean;
  purchasedFastForward: boolean;
  purchasedNoomSummit: boolean;
  skippedNoomSummit: boolean;
  skippedMealDelivery: boolean;
};

const initialState: AddOnsState = {
  purchasedNoomPremium: false,
  purchasedFastForward: false,
  purchasedNoomSummit: false,
  skippedNoomSummit: false,
  skippedMealDelivery: false,
};

const addOnsSlice = createSlice({
  name: "addOns",
  initialState,
  reducers: {
    /* eslint-disable no-param-reassign */
    setPurchasedNoomPremium(state, action: PayloadAction<boolean>) {
      state.purchasedNoomPremium = action.payload;
    },
    setPurchasedFastForward(state, action: PayloadAction<boolean>) {
      state.purchasedFastForward = action.payload;
    },
    setPurchasedNoomSummit(state, action: PayloadAction<boolean>) {
      state.purchasedNoomSummit = action.payload;
    },
    setSkippedNoomSummit(state, action: PayloadAction<boolean>) {
      state.skippedNoomSummit = action.payload;
    },
    setSkippedMealDelivery(state, action: PayloadAction<boolean>) {
      state.skippedMealDelivery = action.payload;
    },

    /* eslint-enable no-param-reassign */
  },
});

export const {
  setPurchasedNoomPremium,
  setPurchasedFastForward,
  setPurchasedNoomSummit,
  setSkippedMealDelivery,
  setSkippedNoomSummit,
} = addOnsSlice.actions;

export default addOnsSlice;
